import Axios from "axios";

export class ServiceCategory {
  // Set service categories url
  constructor(apiUrl, headers) {
    this.serviceCategoryUrl = `${apiUrl}/subscriptions/service-categories`;
    this.headers = headers;
  }

  async getServiceCategoryList() {
    const response = await Axios.get(this.serviceCategoryUrl, {
      headers: this.headers
    });

    return response;
  }

  async createServiceCategory(params) {
    const response = await Axios.post(this.serviceCategoryUrl, params, {
      headers: this.headers
    });

    return response;
  }

  async updateServiceCategory(id, param) {
    const url = `${this.serviceCategoryUrl}/${id}`;

    const response = await Axios.put(url, param, { headers: this.headers });

    return response;
  }

  async deleteServiceCategory(id) {
    const url = `${this.serviceCategoryUrl}/${id}`;

    const response = await Axios.delete(url, { headers: this.headers });

    return response;
  }
}
